/* Transforms the first two words after (and including)
a drop cap into small caps */

export default document.addEventListener('DOMContentLoaded', function () {
  // Element containing the drop cap (assumes will always be a <p> inside of a <div>)
  const dropCapEl = document.querySelector('.js-drop-cap p');

  // Return if no drop cap element
  if (!dropCapEl) return;

  const innerText = dropCapEl.innerText;
  // Split text into separate words
  const words = innerText.split(' ');
  // Get first two words
  const firstTwoWords = `${words[0]} ${words[1]}`;
  // Remove first two words from original innerText
  const newInnerText = innerText.replace(firstTwoWords, '');
  // Update drop cap el with new innerText
  dropCapEl.innerText = newInnerText;

  // Create span el
  const smallCapsEl = document.createElement('span');
  // Add small caps class
  smallCapsEl.classList.add('small-caps');
  smallCapsEl.innerText = firstTwoWords;
  // Attach span to beginning of text
  dropCapEl.prepend(smallCapsEl);
});
